import React from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core';

import Grid, { GridProps } from '../Grid';
import { Typography } from '../Typography';

interface Props {
  title?: string | React.ReactElement;
  subTitle?: string;
  direction?: GridProps['direction'];
  className?: string;
}

const useStyles = makeStyles({
  formSectionWithTitle: {
    margin: '30px auto',
    maxWidth: '100%',
  },
  formSectionWithoutTitle: {
    margin: 'auto',
    maxWidth: '100%',
  },
});

export const FormSection: React.FC<Props> = ({
  title,
  children,
  subTitle,
  direction,
  className,
}) => {
  const classes = useStyles();

  return (
    <Grid
      container
      spacing={4}
      direction={direction || 'column'}
      className={cx(
        title ? classes.formSectionWithTitle : classes.formSectionWithoutTitle,
        className,
      )}
    >
      {title || subTitle ? (
        title && typeof title !== 'string' ? (
          title
        ) : (
          <Grid item>
            {title && <Typography.H2>{title}</Typography.H2>}
            {subTitle && (
              <Typography.Caption color="muted">{subTitle}</Typography.Caption>
            )}
          </Grid>
        )
      ) : null}
      {children}
    </Grid>
  );
};

export default FormSection;
